<template>
  <div class="gm-admin-tab">
    <div class="gm-admin-tab__head">
      <div>
        <h2>{{ $t('frontend_groovemail_admin_bounce_block_settings') }}</h2>
        <p class="gm-admin-tab__hint">{{ $t('frontend_groovemail_admin_configure_settings') }}</p>
      </div>
      <gs-button variant="primary" @click="updatesetting()">{{ $t('frontend_save') }}</gs-button>
    </div>

    <section class="gm-admin-tab__section">
      <h3>{{ $t('frontend_groovemail_settings_bounce_mail') }}</h3>
      <div class="gm-admin-tab__row">
        <gs-field
          :label="$t('frontend_groovemail_settings_convert_soft_bounce')"
          :hint="$t('frontend_groovemail_settings_times_within')"
        >
          <text-input
            variant="base"
            v-model="model.max_count"
            @input="settingsUpdated = true"
            :placeholder="this.$t('frontend_groovemail_admin_settings_enter_max_count')"
            :validator="$v.model.max_count"
          />
        </gs-field>
        <gs-field :label="$t('frontend_groovemail_settings_days_duration')">
          <text-input
            variant="base"
            v-model="model.days_ago"
            @input="settingsUpdated = true"
            :placeholder="this.$t('frontend_groovemail_admin_settings_enter_days_ago')"
            :validator="$v.model.days_ago"
          />
        </gs-field>
      </div>
    </section>

    <section class="gm-admin-tab__section">
      <h3>{{ $t('frontend_groovemail_settings_block_ip') }}</h3>
      <div class="gm-admin-tab__row">
        <gs-field
          :label="$t('frontend_groovemail_settings_user_ip')"
          :hint="$t('frontend_groovemail_settings_minimum_request')"
        >
          <text-input
            variant="base"
            v-model="model.ip_count"
            @input="settingsUpdated = true"
            :placeholder="this.$t('frontend_groovemail_admin_settings_enter_ip_count')"
            :validator="$v.model.ip_count"
          />
        </gs-field>
        <gs-field :label="$t('frontend_groovemail_settings_minutes_submission')">
          <text-input
            variant="base"
            v-model="model.ip_block_time"
            @input="settingsUpdated = true"
            :placeholder="this.$t('frontend_groovemail_admin_settings_enter_ip_request_time')"
            :validator="$v.model.ip_block_time"
          />
        </gs-field>
        <gs-field
          :label="$t('frontend_groovemail_settings_user_blocking')"
          :hint="$t('frontend_groovemail_settings_hours')"
        >
          <text-input
            variant="base"
            v-model="model.user_block_time"
            @input="settingsUpdated = true"
            :placeholder="this.$t('frontend_groovemail_admin_settings_enter_user_block_time')"
            :validator="$v.model.user_block_time"
          />
        </gs-field>
      </div>
    </section>
  </div>
</template>

<script>
import { required, numeric } from 'vuelidate/lib/validators';
import { adminUrls } from '@/utils/urls.js';
import { getData, postData } from '@/utils/apiHelper.js';
import { showErrorDialog } from '@/components/showDialog.js';

export default {
  data() {
    return {
      model: {
        max_count: '',
        days_ago: '',
        ip_count: '',
        ip_block_time: '',
        user_block_time: '',
      },
      settingsUpdated: false,
    };
  },
  validations: {
    model: {
      max_count: {
        required,
        numeric,
      },
      days_ago: {
        required,
        numeric,
      },
      ip_count: {
        required,
        numeric,
      },
      ip_block_time: {
        required,
        numeric,
      },
      user_block_time: {
        required,
        numeric,
      },
    },
  },

  // Initialize data properties with bounce block data .
  async created() {
    await this.initializeBounceBlockData();
  },

  methods: {
    // Fetches bounce block data and initialize them to data properties.
    async initializeBounceBlockData() {
	    const settings = await getData(
        adminUrls.mainSettingsUrl.fetchBounceBlockSettingsData
      );
      if (settings && settings.data) {
        this.model.max_count = settings.data.bounce_count
          ? settings.data.bounce_count
          : 0;
        this.model.days_ago = settings.data.bounce_days
          ? settings.data.bounce_days
          : 0;
        this.model.ip_count = settings.data.block_ip
          ? settings.data.block_ip
          : 0;
        this.model.ip_block_time = settings.data.minute_ip
          ? settings.data.minute_ip
          : 0;
        this.model.user_block_time = settings.data.user_time
          ? settings.data.user_time
          : 0;
      }
    },

    // Validates and save bounce block data.
    async updatesetting() {
      let validity = true;

      this.$v.model.max_count.$touch();
      this.$v.model.days_ago.$touch();
      this.$v.model.ip_count.$touch();
      this.$v.model.ip_block_time.$touch();
      this.$v.model.user_block_time.$touch();

      validity = !(
        this.$v.model.max_count.$invalid ||
        this.$v.model.days_ago.$invalid ||
        this.$v.model.ip_count.$invalid ||
        this.$v.model.ip_block_time.$invalid ||
        this.$v.model.user_block_time.$invalid
      );

      if (this.settingsUpdated) {
        if (validity) {
            await postData(adminUrls.mainSettingsUrl.updateBounceBlockSettings, {
            bounce_max_count: this.model.max_count,
            bounce_days_ago: this.model.days_ago,
            number_ip_block: this.model.ip_count,
            block_ip_minutes: this.model.ip_block_time,
            block_user_time: this.model.user_block_time,
          });
          this.settingsUpdated = false;
        }
      } else {
        await showErrorDialog('', this.$t('frontend_groovemail_admin_bounce_block_settings_update_warning'));  
      }
    },
  },
};
</script>

